import { usePartnership } from './usePartnership';

export const useNoDepositPartnership = () => {
  const partnership = usePartnership();
  return partnership === 'stretchdollar';
};
